import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { api } from "../lib/api";
import { connect, getSocket, wsActions, resync } from "../lib/ws";

// Ensures the WS is connected, joins the lobby by code, and resyncs. Screens
// read state from the gameStore (populated by WS state_update pushes).
export function useLobbyConnection(code: string): void {
  const navigate = useNavigate();
  const username = useAuthStore.getState().username;

  useEffect(() => {
    let disposed = false;
    (async () => {
      const token = useAuthStore.getState().accessToken;
      if (!token) {
        navigate("/");
        return;
      }
      try {
        const info = await api.validateLobby(code);
        if (!info.exists || disposed) {
          navigate("/lobby");
          return;
        }
      } catch {
        navigate("/lobby");
        return;
      }
      // The App-level lifecycle creates the socket at login. If one already
      // exists but is still connecting, wait for its "connect" below instead
      // of tearing it down and rebuilding (a rebuild would clear the lobby
      // attach and lose the B5 auto re-join).
      let socket = getSocket();
      if (!socket) {
        socket = connect();
      }
      const onUp = () => {
        wsActions.join(code, username ?? "Giocatore");
        void resync(code);
      };
      if (socket.connected) {
        onUp();
      } else {
        socket.once("connect", onUp);
      }
    })();
    return () => {
      disposed = true;
    };
  }, [code, username, navigate]);
}
